import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment';
import { DepartmentModel } from '../views/models/department.model';
import { UserModel } from '../views/models/user.model';
import { TokenFormModel } from '../views/pages/auth/models/tokenform.model';
import { AuthService } from './auth/auth.service';
import { HotelModel } from '../views/models/hotel.model';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  record_change$ = new BehaviorSubject<UserModel | undefined>(undefined);
  users_change$ = new BehaviorSubject<UserModel[]>([]);
  department_change$ = new BehaviorSubject<DepartmentModel[]>([]);

  constructor(
    private httpClient: HttpClient,
    private authService: AuthService,
    private router: Router,
    private title: Title) {
    this.getMe();
  }

  getMe() {
    this.httpClient.get(environment.baseURL + '/v2/api' + '/me').subscribe(
      (me: UserModel) => {
        this.title.setTitle(me.hotel_name);
        this.record_change$.next(me);
      },
      error => {
        this.record_change$.next(undefined);
        this.authService.logOff();
        this.router.navigateByUrl('/auth').then();
      }
    );
  }

  putUser(user: UserModel) {
    this.httpClient.put(environment.baseURL + '/v2/api' + '/saveme', user).subscribe(
      () => {
        localStorage.setItem('hotelId', user.app_hotel_id.toString());
        const FORM: TokenFormModel = JSON.parse(localStorage.getItem('token_form'));
        FORM.app_hotel_id = user.app_hotel_id;
        localStorage.setItem('token_form', JSON.stringify(FORM));
        window.location.reload();
      }, (err) => console.log(err)
    );
  }

  postUser(user: UserModel, selectedFile?: string) {
    this.httpClient.post(environment.baseURL + '/v2/api' + '/user', user).subscribe(
      (resp: number) => {
        if (selectedFile) {
          const fd = new FormData();
          fd.append('file', selectedFile, resp.toString());
          this.httpClient.post(environment.baseURL + '/v2/api' + '/uploaddocument?bucketname=b1development&directory=icibotV2/users/', fd)
            .subscribe((data: any) => {
              user.image_url = data.link;
              this.postUser(user);
            },
              (err) => {
                console.log('Err : ' + err);
              }
            );
        }
      }, (err) => console.log(err),
      () => {
        this.getUsers();
      }
    );
  }

  getUsers() {
    this.httpClient.get(environment.baseURL + '/v2/api' + '/users').subscribe(
      (users: UserModel[]) => {
        const roleType = JSON.parse(localStorage.getItem('token_form')).role;
        if (roleType != 'admin') {
          users = users.filter(x => x.role != 'admin');
        }
        this.users_change$.next(users);
      }
    );
  }

  getUsersPromise() {
    return new Promise((resolve, reject) => {
      this.httpClient.get(environment.baseURL + '/v2/api' + '/users').subscribe(
        (users: UserModel[]) => {
          const roleType = JSON.parse(localStorage.getItem('token_form')).role;
          if (roleType != 'admin') {
            users = users.filter(x => x.role != 'admin');
          }
          this.users_change$.next(users);
          resolve(users);
        }
      );
    });
  }

  getUser(id: string) {
    return this.httpClient.get(environment.baseURL + '/v2/api' + '/user/' + id);
  }

  deleteUser(id: string) {
    return this.httpClient.delete(environment.baseURL + '/v2/api' + '/user/' + id);
  }

  getDepartment() {
    this.httpClient.get(environment.baseURL + '/v2/api' + '/department').subscribe(
      (department: DepartmentModel[]) => {
        this.department_change$.next(department);
      }
    );
  }

  getHotels(): Promise<HotelModel[]> {
    return new Promise((resolve, reject) => {
      this.httpClient.get(environment.baseURL + '/v2/api' + '/app_hotels?product_type=guestny').subscribe(
        (hotels: HotelModel[]) => {
          const roleType = JSON.parse(localStorage.getItem('token_form')).role;
          resolve(hotels);
        }
      );
    });
  }
}
